import React from 'react';
// import logo from './logo.svg';
import './App.css';
import Layout from './components/Layout';
// require('dotenv').config();

function App() {
  return (
    <div className="App">
      <Layout/>
    </div>
  );
}

export default App;
